<template>
  <div class="pa-0 ma-0" style="overflow: hidden">
    <!-- top connection -->
    <div :class="`top-connection-${themeName}`"></div>

    <!-- Circle -->
    <div :class="`d-flex align-center justify-center outer-border-${themeName}`">
      <div :class="small ? 'small' : ''" class="primary inner-circle"></div>
    </div>
    <!-- bottom connection -->
    <div v-if="bottomConnection" :class="`bottom-connection-${themeName}`" :style="`height:${cellHeight - 22}px`"></div>
  </div>
</template>

<script>
export default {
  name: 'TimeLinePoint',
  props: {
    themeName: String,
    topConnection: { type: Boolean, default: true },
    bottomConnection: Boolean,
    cellHeight: { type: Number, default: 60 },
    small: Boolean,
  },
};
</script>

<style scoped>
.outer-border-light,
.outer-border-dark {
  border-radius: 16px;
  width: 22px;
  height: 22px;
  z-index: 1;
}
.outer-border-light {
  border: 1px solid #d0d0d0;
}
.outer-border-dark {
  border: 1px solid #d0d0d0;
}
.small {
  width: 10px !important;
  height: 10px !important;
}
.inner-circle {
  border-radius: 10px;
  width: 16px;
  height: 16px;
  border: 3px solid white;
  z-index: 1;
}
.top-connection-light,
.bottom-connection-light {
  border-right: 1px solid #a0a0a0;
}
.top-connection-dark,
.bottom-connection-dark {
  border-right: 1px solid #a0a0a0;
}
.top-connection-light,
.top-connection-dark,
.bottom-connection-light,
.bottom-connection-dark {
  position: relative;
  padding-left: 10px;
  width: 2px;
}
.top-connection-light,
.top-connection-dark {
  top: 0;
  height: 0px;
}
.bottom-connection-light,
.bottom-connection-dark {
  bottom: 0;
}
</style>
